import Navbar from "@/components/Navbar";

export default function NotFoundPage({ title = "Page not found" }) {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="not-found-page">
      <Navbar />
      <main className="mx-auto max-w-xl px-4 py-24 text-center">
        <h1 className="font-display text-3xl font-black">{title}</h1>
        <p className="mt-3 text-sm text-zinc-500">This page is not available in this environment.</p>
        <a href="/" className="mt-8 inline-block text-sm text-zinc-300 underline hover:text-white">
          Back to leaderboard
        </a>
      </main>
    </div>
  );
}
